import { render, staticRenderFns } from "./DosificacionPage.vue?vue&type=template&id=552e2e34"
import script from "./DosificacionPage.js?vue&type=script&lang=js&external"
export * from "./DosificacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports